export type ServiceName =
  | 'host-frontend'
  | 'host-electron'
  | 'realtime-api'
  | 'node-service'
  | 'playjector'
  | 'playcast-service'
  | 'inputcaster-driver'
  | 'marketing-site'
  | 'marketing-demo'
  | 'discord-activity'
  | 'admin-dashboard';

export type LogLevel = 'trace' | 'debug' | 'info' | 'warn' | 'error' | 'fatal';

export interface ObservabilityConfig {
  log_level: LogLevel;
  sentry_sample_rate: number;
  sentry_logging_levels: LogLevel[];
  breadcrumb_categories: string[];
  replay_session_sample_rate: number;
}

export const DEFAULT_OBSERVABILITY_CONFIG: ObservabilityConfig = {
  log_level: 'warn',
  sentry_sample_rate: 0.01,
  sentry_logging_levels: ['error', 'fatal'],
  breadcrumb_categories: ['fetch', 'xhr', 'console', 'navigation'],
  replay_session_sample_rate: 0,
};

/** Ordered severity: trace(0) < debug(1) < info(2) < warn(3) < error(4) < fatal(5). */
export const LOG_LEVEL_SEVERITY: Record<LogLevel, number> = {
  trace: 0,
  debug: 1,
  info: 2,
  warn: 3,
  error: 4,
  fatal: 5,
};

export function isLogLevelEnabled(level: LogLevel, minLevel: LogLevel): boolean {
  return LOG_LEVEL_SEVERITY[level] >= LOG_LEVEL_SEVERITY[minLevel];
}

/**
 * Regex patterns for known noisy errors that should be dropped in `beforeSend`.
 * Downstream phases use these in their `beforeSend` hooks.
 */
export const NOISE_DROP_PATTERNS: RegExp[] = [
  /ResizeObserver loop/,
  /Non-Error promise rejection captured/,
  /Network request failed/,
];
